class PressList extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const buttons = this.querySelectorAll(
      "button[data-press-item], a[data-press-item]"
    );
    const contents = this.querySelectorAll("div[data-press-item]");

    this.addEventListener("mouseover", (e) => {
      const target = e.target.closest("button") || e.target.closest("a");

      if (target) {
        buttons.forEach((button) => button.classList.remove("!opacity-100"));
        contents.forEach((content) => content.classList.add("hidden"));

        target.classList.add("!opacity-100");

        const matchingContent = this.querySelector(
          `div[data-press-item="${target.dataset.pressItem}"]`
        );
        if (matchingContent) {
          matchingContent.classList.remove("hidden");
        }
      }
    });
  }
}

customElements.define("press-list", PressList);
